import { formatDateHuman, parseDateRaw } from "../date-utils";
export const visitHistoryDtoFields = [{
        name: "slaughterDate",
        title: "Data Macellazione",
        render: (record) => formatDateHuman(parseDateRaw(record.slaughterDate))
    }, {
        name: "minLotNumber",
        title: "Lotto Iniziale",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => record.minLotNumber
    }, {
        name: "maxLotNumber",
        title: "Lotto Finale",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => record.maxLotNumber
    }, {
        name: "numItems",
        title: "Numero Capi",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => record.numItems
    }, {
        name: "numLocked",
        title: "Vincoli Sanitari",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => record.numLocked
    }, {
        name: "numBurned",
        title: "Capi Inceneriti",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => record.numBurned
    }];
